import type { XY } from "../xy";
import { Room } from "./room";

export enum RoomType {
	OFFICE = "OFFICE",
	STUDY = "STUDY",
	MACHINES = "MACHINES",
	BARRELS = "BARRELS",
	POWERPLANT1 = "POWERPLANT1",
	POWERPLANT2 = "POWERPLANT2",
	POWERPLANT_CONTROL_ROOM = "POWERPLANT_CONTROL_ROOM",
	OTHER = "OTHER",
}

export const ALL_ROOM_TYPES: RoomType[] = Object.values(RoomType);

export class RobotBaseRoom extends Room {
	type: RoomType | null = null;
	corridor: boolean = false;

	constructor(minXY: XY, maxXY: XY) {
		super(minXY, maxXY);
	}
}
